<template>
<div>
    <booking-trip-leg-dates :leg="leg" :prices="prices"></booking-trip-leg-dates>

    <div class="c-section" v-if="ticket == 'return'">
        <h2 class="c-ttl c-ttl--mdp fw-b">
            From {{getPortById(legs[leg].origin).name}} to {{getPortById(legs[leg].destination).name}}
        </h2>
    </div>

    <loader v-if="loading"></loader>

    <div v-if="offers.length && !loading">
        <booking-trip-leg-offer v-for="offer in offers" v-bind:key="offer.id" :leg="leg" :offer="offer" @showInfo="showInfo"></booking-trip-leg-offer>
    </div>
</div>
</template>

<script>
import Loader from '../components/Loader.vue'
import BookingTripLegDates from './BookingTripLegDates.vue'
import { mapGetters, mapState } from 'vuex'
import Error from '../components/Error.vue'
import BookingTripLegOffer from './BookingTripLegOffer.vue'
export default {
    components: {
        BookingTripLegDates,
        Loader,
        Error,
        BookingTripLegOffer,
    },
    props: {
        loading: Boolean,
        leg: String,
        prices: {
            type: Array,
            default() {
                return []
            }
        },
        offers: {
            type: Array,
            default() {
                return {}
            }
        },
    },
    computed: {
        ...mapState('booking', [
            'legs',
            'ticket',
            'passengersCount',
        ]),
        ...mapGetters([
            'getPortById'
        ]),
    },
    methods: {
        showInfo(section) {
            this.$emit('showInfo', section)
        },
    }
}
</script>